import { useContext } from 'react';
import {
    Table, TableBody, TableCell, Tooltip, Zoom,
    TableHead, TablePagination, TableRow, IconButton, TableFooter, Typography, Chip
} from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import { channelsContext } from '../ChannelsContext';
import { CircleLoader } from 'components';
import { Link } from 'react-router-dom';
import { applicationContext } from 'helpers/services';
import ReferenceDataKey from 'helpers/enums/ReferenceDataKey';

let Results = () => {
    let service = useContext(channelsContext);
    let appService = useContext(applicationContext);

    return (
        <div>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Code</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>Country</TableCell>
                            <TableCell>Options</TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {service.channels.length > 0 &&
                            service.channels
                                .map((channel, index) =>
                                    <TableRow hover key={index}>
                                        <TableCell>{channel.channelCode}</TableCell>
                                        <TableCell>{channel.description}</TableCell>
                                        <TableCell>{appService.referenceData[ReferenceDataKey.ChannelType].getValueByKey(channel.channelType)}</TableCell>
                                        <TableCell>
                                            {channel.allCountries
                                                ? 'All countries'
                                                : appService.referenceData.Country.getValueByKey(channel.countryCode)
                                            }
                                        </TableCell>
                                        <TableCell>
                                            {channel.isDisabled === true &&
                                                <>
                                                    <Chip size="small" color='error' label='Disabled' variant='outlined' />
                                                    &nbsp;
                                                </>
                                            }
                                            {channel.automaticOrderRelease === true &&
                                                <>
                                                    <Chip size="small" label='Automatic order release' variant='outlined' />
                                                    &nbsp;
                                                </>
                                            }
                                            {channel.sendFeesEmail === true &&
                                                <Chip size="small" label='Send fees email' variant='outlined' />
                                            }
                                        </TableCell>
                                        <TableCell align="right">
                                            <Tooltip TransitionComponent={Zoom} title="Edit">
                                                <IconButton
                                                    color="primary"
                                                    size="small"
                                                    component={Link}
                                                    to={{ pathname: `/admin/channel/edit/${channel.id}` }}
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip TransitionComponent={Zoom} title="Delete">
                                                <IconButton
                                                    color="secondary"
                                                    size="small"
                                                    onClick={() => service.deleteChannel(channel.id)}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                )}
                    </TableBody>
                    {service.channels.length === 0 &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={6}>
                                    <Typography variant="subtitle2">No channels found</Typography>
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    }
                </Table>
            }
            {service.isLoading === false &&
                <TablePagination
                    component="div"
                    count={service.recordCount}
                    onPageChange={service.handleChangePage}
                    page={service.search.pageNr}
                    rowsPerPage={service.search.pageSize}
                    rowsPerPageOptions={[service.search.pageSize]}
                />
            }
        </div>
    );
}

export default Results;